import React from "react";

function DocumentPopup({ isOpen, onClose }) {
  if (!isOpen) return null;
  const isMobile = window.innerWidth < 968;

  return (
    <div className="doc-overlay" onClick={onClose}>
      <div className="doc-modal" onClick={(e) => e.stopPropagation()}>
        <button className="doc-close" onClick={onClose}>
          ✕
        </button>

        <iframe
          title="The Anti-Patrirach Manifesto"
          src="https://docs.google.com/document/d/1P26UooefO2ZxrSxJUPLwjvkDCoSZEnLaukbL3O98HQE/preview"
          className="doc-frame"
        />
      </div>
    </div>
  );
}

export default DocumentPopup;